import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AlreadyUsedCodeItem {
  seqNo?: number;
  barcode: string;
  qrCode: string;
  productName?: string;
}

export interface AlreadyAssignedDialogData {
  totalRequested: number;
  usedCount: number;
  availableCount: number;
  alreadyUsedCodes: AlreadyUsedCodeItem[];
}

@Component({
  selector: 'app-already-assigned-dialog',
  templateUrl: './already-assigned-dialog.component.html',
  styleUrls: ['./already-assigned-dialog.component.scss']
})
export class AlreadyAssignedDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AlreadyAssignedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlreadyAssignedDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
